export default __webpack_public_path__ + "static/media/pro-pic.3a199856.PNG";